import { Supertype, supertypeClass, property, Remoteable } from '@haventech/amorphic';
import { defaultAdminRole } from './AuthenticationHelpers';
import { AuthenticatedPrincipal } from './AuthenticatedPrincipal';
import { AuthenticatedAdminPrincipal } from './AuthenticatedAdminPrincipal';

@supertypeClass
export class SecurityContext extends Remoteable(Supertype) {
  @property({ toServer: false })
  principal: AuthenticatedPrincipal | AuthenticatedAdminPrincipal;

  @property({ toServer: false })
  role: string;

  @property({ toServer: false })
  defaultAdminRole: string;

  constructor() {
    super();
  }

  static new(principal, role) {
    return new SecurityContext().init(principal, role);
  }

  init(principal, role) {
    this.principal = principal;
    this.role = role;
    this.defaultAdminRole = defaultAdminRole.call(principal);
    return this;
  }

  isLoggedIn() {
    return !!this.role;
  }
  isAdmin() {
    return this.isLoggedIn() && this.principal.role === this.defaultAdminRole;
  }
}
